import axios from 'axios'

/**
 * @author Nestor Sandoval
 * @description Service for semantic search operations
 * @class SemanticSearchService
 * @date 06-11-2024
 */
class SemanticSearchService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
   * @author Nestor Sandoval
   * @description Perform semantic search using lexical, semantic or mixed approach
   * @date 06-11-2024
   * @param {String} token - Authentication token
   * @param {Object} params - Search parameters
   * @param {String} params.searchText - The text to search for
   * @param {String} params.searchType - The type of search to perform (lexical, semantic, mixed)
   * @param {String} params.companyId - The ID of the company to search within
   * @param {String} params.documentId - The ID of the document to search within (optional)
   * @param {Number} params.limit - The maximum number of results to return
   * @param {Number} params.minSemanticSimilarity - The minimum semantic similarity score to consider
   * @returns {Promise<Object>} Response with search results
   * @memberof SemanticSearchService
   */
  async performSemanticSearch(token, params) {
    const { searchText, searchType = 'mixed', companyId, documentId, limit = 10, minSemanticSimilarity = 0.60 } = params

    try {
      const url = new URL(`${this.apiUrl}/semantic-search`)

      // Add query parameters
      url.searchParams.append('searchText', searchText)
      url.searchParams.append('searchType', searchType)

      if (companyId) {
        url.searchParams.append('companyId', companyId)
      }

      if (documentId) {
        url.searchParams.append('documentId', documentId)
      }

      const response = await axios.get(url.toString(), {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })


      return response.data
    } catch (error) {

      throw error
    }
  }
}

export default SemanticSearchService
